module.exports = __webpack_public_path__ + "static/media/booking-calendar.a05070b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/booking-calendar.png
// module id = 1215
// module chunks = 27